export interface ISortParams {
  key: string;
  typeOfValue: 'string' | 'boolean' | 'date';
  order?: 'asc' | 'desc';
};

export function sort(list: any[], sortParams: ISortParams): any[] {
  return list.sort((a, b) => {
    const valueA = getNestedProperty(a, sortParams.key);
    const valueB = getNestedProperty(b, sortParams.key);

    const processedA = processValueByType(valueA, sortParams.typeOfValue);
    const processedB = processValueByType(valueB, sortParams.typeOfValue);

    const compareValues = (valA: string, valB: string) => {
      if (valA < valB)
        return sortParams.typeOfValue === "boolean" ? 1 : -1;
      if (valA > valB)
        return sortParams.typeOfValue === "boolean" ? -1 : 1;
      return 0;
    };

    if (sortParams.typeOfValue === 'date') {
      return sortParams.order === 'asc'
        ? processedB - processedA : processedA - processedB;
    }

    const comparison = compareValues(processedA, processedB);
    return sortParams.order === 'asc' ? comparison : -comparison;
  });
};

export function getNextSortOrder(
  oldSortParams: ISortParams | undefined,
  newKey: string): 'asc' | 'desc' | undefined {
  if (oldSortParams === undefined ||
    oldSortParams.order === undefined ||
    oldSortParams.key !== newKey ||
    oldSortParams.order === 'desc') {
    return 'asc';
  }
  return 'desc';
}

export function getIndexById(
  list: any[],
  elementId: number | undefined,
  getElementIdFunction: (element: any) => number): number {
  if (elementId !== undefined) {
    return list
      .map((x) => {
        return getElementIdFunction(x);
      })
      .indexOf(elementId);
  }
  return 0;
}

function getNestedProperty(obj: any, path: string): string {
  return path.split('.').reduce((acc, part) =>
    acc && acc[part] !== undefined ? acc[part] : undefined,
    obj
  );
};

function processValueByType(value: any, type: string): any {
  switch (type) {
    case 'boolean':
      return value === false ? 0 : 1;
    case 'string':
      return String(value ?? '').toLowerCase();
    case 'number':
      return Number(value || 0);
    case 'date':
      return value ? new Date(value).getTime() : 0;
    default:
      return value;
  }
};
